import { createAction, props } from '@ngrx/store';

export enum AggregationCountTypes {
    GET_AGGREGATION_DATA = '[Aggregation] Get Aggregation Data',
    SET_AGGERGATION_DATA = '[Aggregation] Set Aggergation Data',
    CLEAR_AGGERGATION_DATA = '[Aggregation] Clear Aggergation Data',
    GET_RECON_CARDINALITY_COUNT = '[Aggregation] Get Recon Cardinality Count',
    SET_RECON_CARDINALITY_COUNT = '[Aggregation] Set Recon Cardinality Count',
}

export const GetAggregationData = createAction(
    AggregationCountTypes.GET_AGGREGATION_DATA,
    props<{
        serviceId?: string;
        instanceId: string;
        parentRecordId: string;
        fieldId: string;
        criteriaName?: string;
        criteria: any;
        from?: 'TAXONOMY';
    }>()
);

export const SetAggregationData = createAction(
    AggregationCountTypes.SET_AGGERGATION_DATA,
    props<{
        instanceId: string;
        parentRecordId: string;
        fieldId: string;
        aggregationResult: any[];
        from?: 'TAXONOMY';
    }>()
);

export const ClearAggregationData = createAction(
    AggregationCountTypes.CLEAR_AGGERGATION_DATA,
    props<{
        instanceId: string;
        parentRecordId: string;
    }>()
);

export const GetReconCardinalityCount = createAction(
    AggregationCountTypes.GET_RECON_CARDINALITY_COUNT,
    props<{
        instanceId: string;
        parentRecordId: string;
        fieldId: string;
        criteria: any;
    }>()
);

export const SetReconCardinalityCount = createAction(
    AggregationCountTypes.SET_RECON_CARDINALITY_COUNT,
    props<{
        instanceId: string;
        parentRecordId: string;
        fieldId: string;
        reconCardinalityCount: number;
    }>()
);
